
import { GET_BUY_SOURCES_SUCCESS } from 'stash/actions/api/buySources';
import { GetBuySourcesSuccessAction } from 'stash/actions/api/buySources';

function buySourcesReducer(state = [], action: GetBuySourcesSuccessAction) {
	switch (action.type) {
		case GET_BUY_SOURCES_SUCCESS:
			return action.response.sources || state;
		default:
			return state;
	}
}

export default buySourcesReducer;
